import script from "./VoteConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./VoteConfirm.vue?vue&type=script&setup=true&lang=js"

import "./VoteConfirm.vue?vue&type=style&index=0&id=5df21038&lang=css"

const __exports__ = script;

export default __exports__